/**
 * Model to map General Information Changes.
 *
 * @author pankaj.khurana@vernuso.com
 */
export class GeneralInfo {
    entityTypeId: number;
    generalInfo: String;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/general-info.model.ts